<div class="chips-header">
  <i class="pi pi-map-marker"></i>
  @if (addingLocation) {
    <span>Saving location...</span>
  } @else {
    @if (type() === types.origin) {
      <span>Place of receipt / Origin Location</span>
      <span class="chips-header__rule"></span>
    }
    @if (type() === types.destination) {
      <span>Destination Location / Place of delivery</span>
    }
  }
</div>

<div class="chips-box" [class.expanded]="isExpanded()">
  <div class="chips-wrapper">
    @if (locations?.length) {
      <p-autocomplete
        [multiple]="true"
        [typeahead]="false"
        [(ngModel)]="locations"
        (onUnselect)="removeElement($event)"
      >
        <ng-template let-item #selecteditem>
          <div
            [class.currently-edited]="currentEditedLocation.getId() === item.id"
            (mousedown)="isExpanded() ? editLocation(item) : false"
          >
            @if (type() === types.origin) {
              <div>
                @if (item.inlandHaulage) {
                  <span>
                    {{ item.inlandHaulage }}
                    <i class="pi pi-arrow-right"></i>
                  </span>
                }
                @if (item.locationGroup) {
                  <strong [pTooltip]="item.locationGroup.locationNames">{{
                    item.locationGroup.name
                  }}</strong>
                }
              </div>
            }
            @if (type() === types.destination) {
              <div>
                @if (item.locationGroup) {
                  <strong [pTooltip]="item.locationGroup.locationNames">{{
                    item.locationGroup.name
                  }}</strong>
                }
                @if (item.inlandHaulage) {
                  <span>
                    <i class="pi pi-arrow-right"></i>
                    {{ item.inlandHaulage }}
                  </span>
                }
              </div>
            }
          </div>
        </ng-template>
      </p-autocomplete>
    }
    @if (locations?.length && !isExpanded()) {
      <button
        type="button"
        class="chips-add"
        data-cy="chips-add"
        aria-label="Add location"
        (click)="looseFocusOnEditedLocation()"
      >
        <i class="pi pi-plus"></i>
      </button>
    }
  </div>
  <div class="add-form">
    <div class="add-form__row">
      @if (type() === types.destination) {
        <div class="add-form__field">
          <span class="add-form__label form-control-label required">
            Destination Location
          </span>
          <app-location-group-select
            [required]="true"
            [disabled]="addingLocation"
            [locationGroup]="currentEditedLocation.locationGroup"
            (locationGroupChange)="currentEditedLocation.locationGroup = $event"
          >
          </app-location-group-select>
        </div>
        <i class="pi pi-arrow-right d-none d-md-inline-block"></i>
      }
      <div class="add-form__field">
        <span class="add-form__label">{{
          type() === types.origin ? "Place of receipt" : "Place of delivery"
        }}</span>
        <app-place-autocomplete
          dataCy="quote-inland"
          [value]="currentEditedLocation.inlandHaulage"
          [disabled]="addingLocation"
          [placeholder]="
            type() === types.origin ? 'Origin Location' : 'Destination Location'
          "
          (valueChange)="onInlandHaulageChange($event)"
          (placeSelect)="onPlaceSelect($event)"
          (pendingChange)="placePending = $event"
        ></app-place-autocomplete>
      </div>
      @if (type() === types.origin) {
        <i class="pi pi-arrow-right d-none d-md-inline-block"></i>
        <div class="add-form__field">
          <span class="add-form__label form-control-label required">
            Origin Location
          </span>
          <app-location-group-select
            [required]="true"
            [disabled]="addingLocation"
            [locationGroup]="currentEditedLocation.locationGroup"
            (locationGroupChange)="currentEditedLocation.locationGroup = $event"
          >
          </app-location-group-select>
        </div>
      }
      <div
        class="add-form__actions"
        [class.edit-mode]="!!currentEditedLocation.getId()"
      >
        @if (!!currentEditedLocation.getId()) {
          <button
            pButton
            severity="primary"
            class="location-save"
            [disabled]="placePending"
            (click)="saveInland()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
        @if (!currentEditedLocation.getId()) {
          <button
            pButton
            severity="primary"
            data-cy="location-add"
            class="location-add"
            [disabled]="!isValid() || placePending"
            (click)="addElement()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
      </div>
    </div>
  </div>
</div>
